import React from 'react';
import CreateTeaserState from './createTeaserState/CreateTeaserState';
import ModalWindows from './components/ModalWindows/ModalWindows';
import ControlPanel from './components/ControlPanel/ControlPanel';
import Forms from './components/Forms/Forms';

const CreateTeaserPage: React.FC = () => {
	return (
		<CreateTeaserState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</CreateTeaserState>
	);
};

export default CreateTeaserPage;
